import { StoreState } from '../../types';

export const getOverview = (store: StoreState) => store.managerDashboard.overview.overview;